/* NOLTO — shared theme behaviour (Shopify Online Store 2.0) */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var config = window.NoltoTheme || {};

  /* ---------------- money formatting ---------------- */
  function formatMoney(cents) {
    var format = config.moneyFormat || "{{amount}} lei";
    var amount = (cents / 100).toFixed(2).replace(".", ",");
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/<[^>]+>/g, "");
  }

  /* ---------------- header scroll state ---------------- */
  var header = document.getElementById("siteHeader");
  function updateHeaderScroll() {
    if (!header) return;
    if (window.scrollY > 10) {
      header.classList.add("nolto-is-scrolled");
    } else {
      header.classList.remove("nolto-is-scrolled");
    }
  }
  updateHeaderScroll();
  window.addEventListener("scroll", updateHeaderScroll, { passive: true });

  /* ---------------- scroll progress line ---------------- */
  var scrollProgressEl = document.getElementById("scrollProgress");
  function updateScrollProgress() {
    if (!scrollProgressEl) return;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
    scrollProgressEl.style.width = pct + "%";
  }
  if (scrollProgressEl) {
    updateScrollProgress();
    window.addEventListener("scroll", function () {
      requestAnimationFrame(updateScrollProgress);
    }, { passive: true });
    window.addEventListener("resize", updateScrollProgress);
  }

  /* ---------------- mobile menu ---------------- */
  var hamburger = document.getElementById("hamburgerBtn");
  var mobilePanel = document.getElementById("mobilePanel");
  if (hamburger && mobilePanel) {
    hamburger.addEventListener("click", function () {
      var isOpen = mobilePanel.classList.toggle("nolto-is-open");
      hamburger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      header.classList.toggle("nolto-menu-open", isOpen);
      document.body.style.overflow = isOpen ? "hidden" : "";
    });
    mobilePanel.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobilePanel.classList.remove("nolto-is-open");
        hamburger.setAttribute("aria-expanded", "false");
        header.classList.remove("nolto-menu-open");
        document.body.style.overflow = "";
      });
    });
  }

  /* ---------------- search overlay ---------------- */
  var searchToggle = document.getElementById("searchToggle");
  var searchOverlay = document.getElementById("searchOverlay");
  if (searchToggle && searchOverlay) {
    var searchInput = searchOverlay.querySelector("input[type='search']");
    var searchClose = searchOverlay.querySelector(".nolto-search-close");
    function openSearch() {
      searchOverlay.classList.add("nolto-is-open");
      setTimeout(function () { searchInput && searchInput.focus(); }, 200);
    }
    function closeSearch() {
      searchOverlay.classList.remove("nolto-is-open");
    }
    searchToggle.addEventListener("click", openSearch);
    searchClose && searchClose.addEventListener("click", closeSearch);
    searchOverlay.addEventListener("click", function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeSearch();
    });
  }

  /* ---------------- scroll reveal ---------------- */
  /* Only the brand-story text block keeps a reveal animation now
     (.nolto-story-reveal). Every other section's .nolto-reveal is inert
     via CSS (opacity:1), so it no longer needs JS-driven visibility. */
  var io = null;
  if ("IntersectionObserver" in window && !prefersReducedMotion) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("nolto-is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" });
    document.querySelectorAll(".nolto-story-reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".nolto-story-reveal").forEach(function (el) { el.classList.add("nolto-is-visible"); });
  }

  /* ---------------- magnetic buttons ---------------- */
  /* Perf: batch the style write to one per animation frame instead of one
     per mousemove event (mousemove can fire far more often than the screen
     repaints), so the main thread isn't kept busy with redundant style
     writes right when a click might be queued behind it (hurts INP). */
  if (!prefersReducedMotion) {
    document.querySelectorAll(".nolto-magnetic").forEach(function (btn) {
      var magTicking = false;
      var magX = 0;
      var magY = 0;
      btn.addEventListener("mousemove", function (e) {
        var rect = btn.getBoundingClientRect();
        magX = e.clientX - rect.left - rect.width / 2;
        magY = e.clientY - rect.top - rect.height / 2;
        if (!magTicking) {
          magTicking = true;
          requestAnimationFrame(function () {
            btn.style.transform = "translate(" + (magX * 0.18) + "px," + (magY * 0.35) + "px)";
            magTicking = false;
          });
        }
      });
      btn.addEventListener("mouseleave", function () {
        btn.style.transform = "";
      });
    });
  }

  /* ---------------- ripple (primary buttons + filter chips) ---------------- */
  /* Perf: .nolto-btn and .nolto-chip are already position:relative in CSS,
     so the previous getComputedStyle() read on every click (a forced
     synchronous layout recalculation) was redundant — removed. This was a
     direct INP cost since it ran on every single button/chip click. */
  if (!prefersReducedMotion) {
    document.addEventListener("click", function (e) {
      var target = e.target.closest(".nolto-btn-primary, .nolto-chip");
      if (!target) return;
      var rect = target.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height) * 1.2;
      var ripple = document.createElement("span");
      ripple.className = "nolto-ripple";
      ripple.style.width = ripple.style.height = size + "px";
      ripple.style.left = (e.clientX - rect.left - size / 2) + "px";
      ripple.style.top = (e.clientY - rect.top - size / 2) + "px";
      target.appendChild(ripple);
      ripple.addEventListener("animationend", function () {
        ripple.remove();
      });
    });
  }

  /* ---------------- hero scroll parallax ---------------- */
  var heroSection = document.getElementById("nolto-hero");
  var heroContent = heroSection && heroSection.querySelector(".nolto-hero-content");
  if (heroSection && heroContent && !prefersReducedMotion) {
    var parallaxTicking = false;
    function updateParallax() {
      parallaxTicking = false;
      var heroHeight = heroSection.offsetHeight || 1;
      var progress = Math.min(Math.max(window.scrollY / heroHeight, 0), 1);
      heroContent.style.transform = "translateY(" + (progress * 70) + "px)";
      heroContent.style.opacity = String(1 - progress * 0.85);
    }
    window.addEventListener("scroll", function () {
      if (parallaxTicking) return;
      parallaxTicking = true;
      requestAnimationFrame(updateParallax);
    }, { passive: true });
    updateParallax();
  }

  /* ---------------- counters (wishlist / cart badges) ---------------- */
  function setCount(key, value) {
    document.querySelectorAll('[data-count="' + key + '"]').forEach(function (el) {
      el.textContent = String(value);
      el.classList.toggle("nolto-show", value > 0);
    });
  }
  function bumpCount(key) {
    if (prefersReducedMotion) return;
    document.querySelectorAll('[data-count="' + key + '"]').forEach(function (el) {
      el.classList.remove("nolto-bump");
      void el.offsetWidth;
      el.classList.add("nolto-bump");
    });
  }

  /* wishlist: no native Shopify equivalent, stored locally in the browser */
  function getWishlistSet() {
    try {
      return new Set(JSON.parse(localStorage.getItem("noltoWishlist") || "[]"));
    } catch (e) {
      return new Set();
    }
  }
  function saveWishlistSet(set) {
    localStorage.setItem("noltoWishlist", JSON.stringify(Array.from(set)));
    setCount("wishlist", set.size);
  }
  setCount("wishlist", getWishlistSet().size);

  function refreshWishlistButtons() {
    var set = getWishlistSet();
    document.querySelectorAll(".nolto-product-card[data-product-id]").forEach(function (card) {
      var id = card.getAttribute("data-product-id");
      var btn = card.querySelector("[data-wishlist-toggle]");
      if (!btn) return;
      var active = set.has(id);
      btn.classList.toggle("nolto-is-active", active);
      btn.setAttribute("aria-pressed", String(active));
    });
  }
  refreshWishlistButtons();

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    var card = btn.closest("[data-product-id]");
    if (!card) return;
    var id = card.getAttribute("data-product-id");
    var set = getWishlistSet();
    var active;
    if (set.has(id)) {
      set.delete(id);
      active = false;
    } else {
      set.add(id);
      active = true;
    }
    saveWishlistSet(set);
    btn.classList.toggle("nolto-is-active", active);
    btn.setAttribute("aria-pressed", String(active));
    if (active) {
      btn.classList.remove("nolto-pop");
      void btn.offsetWidth;
      btn.classList.add("nolto-pop");
      bumpCount("wishlist");
    }
  });

  /* ---------------- cart: real Shopify AJAX Cart API ---------------- */
  function refreshCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount("cart", cart.item_count);
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch((config.routes && config.routes.cartAdd) || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = (data && data.description) || "Nu am putut adăuga produsul în coș.";
          throw new Error(message);
        }
        return data;
      });
    });
  }

  /* ---------------- product card: variant image swap on swatch click ---------------- */
  document.addEventListener("click", function (e) {
    var swatchBtn = e.target.closest(".nolto-product-card .nolto-swatch, .nolto-product-card .nolto-variant-pill");
    if (!swatchBtn) return;
    var card = swatchBtn.closest(".nolto-product-card");
    var wrap = swatchBtn.closest(".nolto-variant-swatches");
    if (!card || !wrap) return;
    wrap.querySelectorAll(".nolto-swatch, .nolto-variant-pill").forEach(function (b) { b.classList.remove("nolto-active"); });
    swatchBtn.classList.add("nolto-active");

    var productUrl = card.getAttribute("data-product-url");
    var value = swatchBtn.getAttribute("data-variant-value");
    var img = card.querySelector("[data-product-img]");
    if (!productUrl || !img) return;

    fetch(productUrl + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var match = (product.variants || []).find(function (v) {
          return v.option1 === value || v.option2 === value || v.option3 === value;
        });
        if (match && match.featured_image && match.featured_image.src) {
          img.src = match.featured_image.src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_800x$1$2");
          img.alt = product.title + " – " + value;
        }
      })
      .catch(function () {});
  });

  /* ---------------- card 3D tilt (desktop only) ---------------- */
  /* Perf: same rAF-batching fix as the magnetic buttons above — read the
     pointer position on every mousemove but only write the transform once
     per animation frame. */
  var tiltEnabled = !prefersReducedMotion && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  function bindTilt(card) {
    if (!tiltEnabled || card.dataset.tiltBound) return;
    card.dataset.tiltBound = "true";
    var tiltTicking = false;
    var curRotateX = 0;
    var curRotateY = 0;
    card.addEventListener("mousemove", function (e) {
      var rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      curRotateX = (py * -8).toFixed(2);
      curRotateY = (px * 8).toFixed(2);
      if (!tiltTicking) {
        tiltTicking = true;
        requestAnimationFrame(function () {
          card.style.transform = "translateY(-4px) perspective(800px) rotateX(" + curRotateX + "deg) rotateY(" + curRotateY + "deg)";
          tiltTicking = false;
        });
      }
    });
    card.addEventListener("mouseleave", function () {
      card.style.transform = "";
    });
  }
  document.querySelectorAll(".nolto-category-card, .nolto-product-card").forEach(bindTilt);

  /* ---------------- quick view modal ---------------- */
  var qvOverlay = document.getElementById("quickViewModal");
  if (qvOverlay) {
    var qvClose = qvOverlay.querySelector(".nolto-modal-close");
    var qvMediaSpan = qvOverlay.querySelector(".nolto-modal-media span");
    var qvMediaImg = qvOverlay.querySelector(".nolto-modal-media-img");
    var qvMedia = qvOverlay.querySelector(".nolto-modal-media");
    var qvCat = qvOverlay.querySelector(".nolto-modal-cat");
    var qvName = qvOverlay.querySelector(".nolto-modal-name");
    var qvDescription = qvOverlay.querySelector(".nolto-modal-description");
    var qvPriceCurrent = qvOverlay.querySelector(".nolto-modal-price-current");
    var qvPriceOld = qvOverlay.querySelector(".nolto-modal-price-old");
    var qvVariantsWrap = qvOverlay.querySelector(".nolto-modal-variants");
    var qvVariantsSwatches = qvOverlay.querySelector(".nolto-modal-variants .nolto-variant-swatches");
    var qvQtyValue = qvOverlay.querySelector(".nolto-qty-value");
    var qvAddBtn = qvOverlay.querySelector(".nolto-modal-add-btn");
    var qvMsg = qvOverlay.querySelector(".nolto-modal-add-msg");
    var qty = 1;
    var currentProduct = null;
    var selections = [];

    function setMedia(src, alt) {
      if (src) {
        qvMediaImg.src = src;
        qvMediaImg.alt = alt || "";
        qvMediaImg.hidden = false;
        qvMediaSpan.hidden = true;
        qvMedia.style.background = "";
      } else {
        qvMediaImg.hidden = true;
        qvMediaSpan.hidden = false;
        qvMediaSpan.textContent = (alt || "?").charAt(0);
        qvMedia.style.background = "linear-gradient(150deg,#DCE6F7 0%,#B9CBEB 100%)";
      }
    }

    function setPrice(price, compareAtPrice) {
      qvPriceCurrent.textContent = formatMoney(price);
      if (compareAtPrice && compareAtPrice > price) {
        qvPriceOld.textContent = formatMoney(compareAtPrice);
        qvPriceOld.style.display = "";
      } else {
        qvPriceOld.style.display = "none";
      }
    }

    function findMatchingVariant() {
      return (currentProduct.variants || []).find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selections.every(function (val, i) { return val == null || opts[i] === val; });
      });
    }

    function isColorOptionName(name) {
      var down = (name || "").toLowerCase();
      return down.indexOf("culoare") > -1 || down.indexOf("color") > -1;
    }

    function updateFromVariant(variant) {
      if (!variant) {
        qvAddBtn.disabled = true;
        qvMsg.textContent = "Combinație indisponibilă.";
        return;
      }
      qvAddBtn.disabled = !variant.available;
      qvMsg.textContent = variant.available ? "" : "Stoc epuizat pentru această variantă.";
      setPrice(variant.price, variant.compare_at_price);
      var img = (variant.featured_image && variant.featured_image.src) || (currentProduct.featured_image && currentProduct.featured_image.src);
      setMedia(img, currentProduct.title);
      qvAddBtn.dataset.variantId = variant.id;
    }

    function renderQvOptions(product) {
      var hasRealOptions = product.options && product.options.length && product.options[0] !== "Title";
      if (!hasRealOptions) {
        qvVariantsWrap.style.display = "none";
        selections = [product.variants[0] ? product.variants[0].option1 : null];
        return;
      }
      qvVariantsWrap.style.display = "";
      selections = product.variants[0] ? [product.variants[0].option1, product.variants[0].option2, product.variants[0].option3] : [];

      var optionIndex = 0; /* render selector for the first option only, matching the compact card UI */
      var optionName = product.options[optionIndex];
      var seen = [];
      var values = [];
      product.variants.forEach(function (v) {
        var val = [v.option1, v.option2, v.option3][optionIndex];
        if (val && seen.indexOf(val) === -1) { seen.push(val); values.push(val); }
      });

      qvVariantsSwatches.innerHTML = values
        .map(function (val, i) {
          if (isColorOptionName(optionName)) {
            return '<button type="button" class="swatch' + (i === 0 ? " active" : "") + '" data-value="' + val + '" aria-label="' + val + '"></button>';
          }
          return '<button type="button" class="variant-pill' + (i === 0 ? " active" : "") + '" data-value="' + val + '">' + val + "</button>";
        })
        .join("");

      qvVariantsSwatches.querySelectorAll("[data-value]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          qvVariantsSwatches.querySelectorAll("[data-value]").forEach(function (b) { b.classList.remove("nolto-active"); });
          btn.classList.add("nolto-active");
          selections[optionIndex] = btn.getAttribute("data-value");
          updateFromVariant(findMatchingVariant());
        });
      });
    }

    function open(product) {
      currentProduct = product;
      qty = 1;
      qvMsg.textContent = "";
      qvAddBtn.disabled = false;
      qvCat.textContent = product.type || "";
      qvName.textContent = product.title;
      var plainDescription = (product.description || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
      qvDescription.textContent = plainDescription.length > 180 ? plainDescription.slice(0, 180) + "…" : plainDescription;
      qvDescription.hidden = !plainDescription;
      qvQtyValue.textContent = "1";
      renderQvOptions(product);
      updateFromVariant(findMatchingVariant() || product.variants[0]);
      qvOverlay.classList.add("nolto-is-open");
      qvOverlay.setAttribute("aria-hidden", "false");
    }
    function close() {
      qvOverlay.classList.remove("nolto-is-open");
      qvOverlay.setAttribute("aria-hidden", "true");
    }
    qvClose && qvClose.addEventListener("click", close);
    qvOverlay.addEventListener("click", function (e) {
      if (e.target === qvOverlay) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    qvOverlay.querySelector(".nolto-qty-minus").addEventListener("click", function () {
      qty = Math.max(1, qty - 1);
      qvQtyValue.textContent = String(qty);
    });
    qvOverlay.querySelector(".nolto-qty-plus").addEventListener("click", function () {
      qty += 1;
      qvQtyValue.textContent = String(qty);
    });

    qvAddBtn.addEventListener("click", function () {
      var variantId = qvAddBtn.dataset.variantId;
      if (!variantId) return;
      addToCart(variantId, qty)
        .then(function () {
          qvMsg.textContent = "Adăugat în coș.";
          qvAddBtn.classList.add("nolto-is-success");
          refreshCartCount();
          bumpCount("cart");
          setTimeout(function () { qvAddBtn.classList.remove("nolto-is-success"); }, 1200);
        })
        .catch(function (err) {
          qvMsg.textContent = err.message;
        });
    });

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-quick-view]");
      if (!trigger) return;
      var url = trigger.getAttribute("data-product-url");
      if (!url) return;
      fetch(url + ".js")
        .then(function (r) { return r.json(); })
        .then(open)
        .catch(function () {});
    });
  }

  /* ---------------- animated counters (stat values) ---------------- */
  function animateCounterEl(el) {
    var text = el.textContent;
    var matches = text.match(/\d+/g);
    if (!matches) return;
    var targets = matches.map(Number);
    var duration = 1200;
    var startTime = null;
    function frame(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var i = 0;
      el.textContent = text.replace(/\d+/g, function () {
        var val = Math.round(targets[i] * eased);
        i++;
        return String(val);
      });
      if (progress < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  var statEls = document.querySelectorAll(".nolto-stat-value");
  if (statEls.length && !prefersReducedMotion && "IntersectionObserver" in window) {
    var statObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounterEl(entry.target);
          statObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    statEls.forEach(function (el) { statObserver.observe(el); });
  }

  /* ---------------- catalog toolbar: instant client-side filter + sort ---------------- */
  var catalogGrid = document.getElementById("catalogGrid");
  if (catalogGrid) {
    var chips = document.querySelectorAll("#filterChips .nolto-chip");
    var resultCount = document.getElementById("resultCount");
    var sortSelect = document.getElementById("sortSelect");
    var cards = Array.prototype.slice.call(catalogGrid.querySelectorAll(".nolto-product-card"));
    var hashCategory = decodeURIComponent(window.location.hash.replace("#", ""));

    var activeFilter = "Toate";
    chips.forEach(function (chip) {
      if (hashCategory && chip.getAttribute("data-filter") === hashCategory) {
        activeFilter = hashCategory;
      }
    });

    function render() {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var matches = activeFilter === "Toate" || card.getAttribute("data-category") === activeFilter;
        card.hidden = !matches;
        if (matches) {
          visibleCount++;
          card.classList.add("nolto-is-visible");
        }
      });
      if (resultCount) {
        resultCount.textContent = visibleCount + (visibleCount === 1 ? " produs" : " produse");
      }
      if (sortSelect && sortSelect.value !== "recommended") {
        var visibleCards = cards.filter(function (c) { return !c.hidden; });
        visibleCards.sort(function (a, b) {
          var pa = parseFloat(a.getAttribute("data-price")) || 0;
          var pb = parseFloat(b.getAttribute("data-price")) || 0;
          return sortSelect.value === "price-asc" ? pa - pb : pb - pa;
        });
        /* Perf: batch the reorder into a DocumentFragment instead of calling
           appendChild once per card directly on the live grid — that was
           forcing a layout reflow per card on every filter/sort click,
           which is a direct, visible-to-the-user INP cost on the catalog
           page. Same end result, one reflow instead of N. */
        var frag = document.createDocumentFragment();
        visibleCards.forEach(function (c) { frag.appendChild(c); });
        catalogGrid.appendChild(frag);
      }
    }

    chips.forEach(function (chip) {
      chip.classList.toggle("nolto-active", chip.getAttribute("data-filter") === activeFilter);
      chip.addEventListener("click", function () {
        activeFilter = chip.getAttribute("data-filter");
        chips.forEach(function (c) { c.classList.remove("nolto-active"); });
        chip.classList.add("nolto-active");
        render();
      });
    });
    sortSelect && sortSelect.addEventListener("change", render);
    render();
  }
})();
